import { useTranslation } from "react-i18next";

function PlaceholderIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#C0DD97"
      strokeWidth="1.5"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="3" y1="3" x2="21" y2="21" />
      <line x1="21" y1="3" x2="3" y2="21" />
    </svg>
  );
}

export default function RawMaterialCard({ material, onClick }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.startsWith("ar");
  const { name, family, cas_number, description, image, categories } = material;

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
      aria-label={`${t("marketplace.viewDetails")} ${name}`}
      dir={isRtl ? "rtl" : "ltr"}
      style={{
        background: "#ffffff",
        border: "1px solid #e9f0eb",
        borderRadius: "18px",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.22s ease",
        outline: "none",
        position: "relative",
        zIndex: "1",
        boxSizing: "border-box",
        width: "100%",
        textAlign: isRtl ? "right" : "left",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#0c6839";
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 10px 28px rgba(12,104,57,0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#e9f0eb";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          height: "170px",
          background: "#edf5ee",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {image ? (
          <img
            src={image}
            alt={name}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <PlaceholderIcon />
        )}
      </div>

      <div style={{ padding: "18px", boxSizing: "border-box" }}>
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "700",
            color: "#1a1f1c",
            lineHeight: "1.4",
            marginBottom: "12px",
            marginTop: "0",
          }}
        >
          {name}
        </h3>

        <div
          style={{
            display: "flex",
            gap: "6px",
            flexWrap: "wrap",
            marginBottom: "14px",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#0c6839",
              background: "rgba(12,104,57,0.1)",
              padding: "4px 12px",
              borderRadius: "20px",
            }}
          >
            {family?.name || t("products.chemicals")}
          </span>

          {categories?.[0] && (
            <span
              style={{
                fontSize: "12px",
                fontWeight: "600",
                color: "#6b7280",
                background: "#f3f4f6",
                padding: "4px 12px",
                borderRadius: "20px",
              }}
            >
              {categories[0].name}
            </span>
          )}
        </div>

        <p
          style={{
            fontSize: "13px",
            color: "#6b7280",
            lineHeight: "1.6",
            marginBottom: "18px",
            marginTop: "0",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {description}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            paddingTop: "14px",
            borderTop: "1px solid #f0f4f1",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: isRtl ? "flex-start" : "flex-end", 
              gap: "2px",
              width: "100%",
            }}
          >
            <span style={{ fontSize: "11px", color: "#9ca3af" }}>
              {t("products.casNumber")}
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "700", color: "#1a1f1c" }}
            >
              {cas_number || "N/A"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
